import { Component, Input, ChangeDetectionStrategy, Injector, TemplateRef, QueryList, ContentChildren } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * フォーム項目
 *【エラーメッセージ:errorMessages:{modelPath:string, message:string}[]】
 *【表示条件:visible:boolean】
 *【ラベル内容:labelContent:string】
 *【ツールチップ表示内容:tooltipContent:string】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-form-item',
  templateUrl: './form-item.html',
  styles: [`
    
  `]
})
export class FormItem extends BaseWidget {
  /**
   * 子要素
   */
  children:TemplateRef<any>[]

  @ContentChildren(TemplateRef) templateRefs:QueryList<TemplateRef<any>>

  ngAfterContentInit() {
    this.children = this.templateRefs.toArray()
  }
  /**
   * エラーメッセージ
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * ツールチップ表示内容
   */
  @Input() tooltipContent:string

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/form/form-item/form-item.component.ts